import DashboardDetails from "@/modules/subscription/views/SubscriptionDetails.vue";

export const SubscriptionDetailsRoutes = [
    {
        name: 'Details',
        path: '/subscription/details',
        component: DashboardDetails,
    }
];
